<template>
    <footer class="container-fluid bg-dark text-white pt-3 pt-md-4 pt-lg-5 px-3 px-md-4 px-lg-5 pb-2">
        <b-row cols="1" cols-md="3" class="mb-5">
            <b-col>
                <h3>A propos</h3>
                <ul>
                    <li>
                        <b-link :to="'/conditions-generales-services'">Conditions Générales de Services</b-link>
                    </li>

                    <li>
                        <b-link href="https://www.assistel.paris/mentions-legales">Mentions légales</b-link>
                    </li>
                </ul>
            </b-col>

            <b-col>
                <h3>Nos services</h3>
                <ul>
                    <li>
                        <b-link :to="'/domiciliation/accueil'">Création & Domiciliation</b-link>
                    </li>

                    <li>
                        <b-link href="https://www.assistel.paris/permanence-telephone-medical-paris">Permanence téléphonique médicale</b-link>
                    </li>

                    <li>
                        <b-link href="https://www.assistel.paris/secretariat-externalise-paris">Standard externalisé</b-link>
                    </li>

                    <li>
                        <b-link href="https://www.assistel.paris/contact">Contact</b-link>
                    </li>

                    <li>
                        <b-link href="https://www.assistel.paris/blog">Blog</b-link>
                    </li>
                </ul>
            </b-col>

            <b-col>
                <h3>Suivez Assistel</h3>

                <div class="d-flex">
                    <a href="https://www.linkedin.com/company/assistel-paris" target="_blank" rel="noopener">
                        <img :src="social.linkedin" alt="Logo de LinkedIn" width="25" />
                    </a>
                </div>
            </b-col>
        </b-row>

        <p class="text-center text-gray">{{ copyright }}</p>
    </footer>
</template>

<script>
    import SVGInject from '@iconfu/svg-inject';

    export default {
        data() {
            return {
                social: {
                    linkedin: require('@/assets/images/icons/social/linkedin.svg')
                }
            }
        },
        computed: {
            copyright() {
                const CURRENT_YEAR = new Date().getFullYear();
                return `© Assistel ${CURRENT_YEAR} - Tous droits réservés`
            }
        },
        mounted() {
            SVGInject(document.querySelector("footer img"));
        }
    }
</script>

<style lang="scss">
    footer
    {
        ul
        {
            list-style: none;
            padding-left: 0;
        }

        a
        {
            color: #969696;

            &:hover
            {
                color: white;

                path 
                {
                    fill: white
                }
            }
        }
    }
</style>
